import execute_on from "../../../libs/execute-on";
import {attachDataTables} from "../../../plugins/datatables";
import {getCsrfToken} from "../../../plugins/get-csrf-token";
import {swalWarningFire} from "../../../plugins/sweet-alert/sweet-alert-default";
import "datatables.net";
import "datatables.net-bs4";
import {showAnkieterData, removeMarkedRows} from "./manage-data";

execute_on('survey.report.summary', function ($page) {
    // elements
    const $manageDataButton = $('#manage-data');

    // handlers
    $manageDataButton.on('click', showAnkieterData);
    $page.on('click', '#manage-data-delete', removeMarkedRows);
    $page
        .on('click', '.showHistoryReportsModal', function (event) {
            event.preventDefault();

            const $showHistoryReportsModal = $(document.getElementById('historyReportsModal'));
            const historyReportsListUrl = $showHistoryReportsModal.data('url');

            $showHistoryReportsModal
                .modal('show')
                .css('z-index', 1041)
                .find('.modal-content')
                .html('<div class="m-5 text-center">' +
                    '<div class="spinner-border mb-3" role="status"></div>' +
                    '<strong class="d-block">Loading data, please wait...</strong>' +
                    '</div>')
                .load(historyReportsListUrl, function (responseText, textStatus) {
                    if ('error' === textStatus) {
                        return $(this).html(responseText);
                    }

                    attachDataTables($showHistoryReportsModal);
                });
        })
        .on('click', '.downloadSelectedReports', function (event) {
            event.preventDefault();

            const downloadZipReportsUrl = $(this).parent('a').attr('href');
            const $showHistoryReportsModal = $(document.getElementById('historyReportsModal'));
            const dataTable = $showHistoryReportsModal.find('.dataTable').first().DataTable();
            const data = new FormData();

            let reportCount = 0;
            $(dataTable.$('td.selectReport input[type="checkbox"]:checked').each(function (i) {
                const reportId = $(this).data('id');
                data.append('reports[' + i + '][id]', reportId);
                reportCount++;
            }));

            if (1 > reportCount) {
                swalWarningFire({
                    'title': 'Minimum number of reports',
                    'text': 'You must select at least one report for download.',
                });

                return;
            }

            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    const a = document.createElement('a');
                    a.href = window.URL.createObjectURL(xhttp.response);
                    a.download = "reports.zip";
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                }
            };

            xhttp.open("POST", downloadZipReportsUrl);
            xhttp.setRequestHeader('X-CSRF-TOKEN', getCsrfToken());
            xhttp.responseType = 'blob';
            xhttp.send(data);
        })
        .on('click', '.downloadSelectedInvoices', function (event) {
            event.preventDefault();

            const downloadZipInvoicesUrl = $(this).parent('a').attr('href');
            const $showHistoryReportsModal = $(document.getElementById('historyReportsModal'));
            const dataTable = $showHistoryReportsModal.find('.dataTable').first().DataTable();
            const data = new FormData();

            let invoiceCount = 0;
            $(dataTable.$('td.selectReport input[type="checkbox"]:checked').each(function (i) {
                const invoiceId = $(this).closest('td').children('.invoiceId').val();
                data.append('invoice[' + i + '][id]', invoiceId);
                invoiceCount++;
            }));

            if (1 > invoiceCount) {
                swalWarningFire({
                    'title': 'Minimum number of invoices',
                    'text': 'You must select at least one invoice for download.',
                });

                return;
            }

            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    const a = document.createElement('a');
                    a.href = window.URL.createObjectURL(xhttp.response);
                    a.download = "invoices.zip";
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                }
            };

            xhttp.open("POST", downloadZipInvoicesUrl);
            xhttp.setRequestHeader('X-CSRF-TOKEN', getCsrfToken());
            xhttp.responseType = 'blob';
            xhttp.send(data);
        })
        .on('click', '.deleteSelectedReports', function (event) {
            event.preventDefault();

            const deleteReportUrl = $(this).parent('a').attr('href');
            const $showHistoryReportsModal = $(document.getElementById('historyReportsModal'));
            const dataTable = $showHistoryReportsModal.find('.dataTable').first().DataTable();
            let reportIds = {};
            $(dataTable.$('td.selectReport input[type="checkbox"]:checked').each(function (i) {
                reportIds['reports[' + i + '][id]'] = $(this).data('id');
            }));

            if (Object.keys(reportIds).length < 1) {
                swalWarningFire({
                    'title': 'Minimum number of reports',
                    'text': 'You must select at least one report for delete.',
                });

                return;
            }

            $.ajax(deleteReportUrl, {
                data: reportIds,
                method: 'DELETE',
                headers: {'X-CSRF-TOKEN': getCsrfToken()},
            }).done(function () {
                $showHistoryReportsModal
                    .find('.modal-content')
                    .html('<div class="m-5 text-center">' +
                        '<div class="spinner-border mb-3" role="status"></div>' +
                        '<strong class="d-block">Loading data, please wait...</strong>' +
                        '</div>')
                    .load($showHistoryReportsModal.data('url'), function (responseText, textStatus) {
                        if ('error' === textStatus) {
                            return $(this).html(responseText);
                        }

                        attachDataTables($showHistoryReportsModal);
                    });
            });
        })
    ;

});
